import { get, post } from "./fetch.core";
import {
  AppendDeliveryFormData,
  DeliveryListFilter,
  DeliverySchedule,
  DeliveryScheduleFormData,
  DeliveryScheduleListScope,
  DeliveryVehicle,
  DeliveryVehicleFormData,
  FinalizeScheduleFormData,
  PendingDeliveryScheduleFormData,
  PendingItemsResponse,
  UpdateLogisticShippingFormData,
} from "../types/delivery";
import { Order } from "../types/order";

async function createVehicle(data: DeliveryVehicleFormData) {
  await post("/admin/delivery/createVehicle", data);
}

export async function listVehicles() {
  const rst = await get<DeliveryVehicle[]>("/admin/delivery/listVehicle");
  return rst.data;
}

async function updateVehicle(data: DeliveryVehicleFormData, id: string) {
  await post(`/admin/delivery/updateVehicle`, { id, ...data });
}

async function getVehicle(id: string) {
  const rst = await get<DeliveryVehicle>(`/admin/delivery/getVehicle?id=${id}`);
  return rst.data;
}

async function createSchedule(data: PendingDeliveryScheduleFormData) {
  if (!Array.isArray(data.orderItemIds)) {
    data.orderItemIds = [data.orderItemIds];
  }

  await post("/admin/delivery/createSchedule", data);
}

export async function listSchedules(scope: DeliveryScheduleListScope = "all") {
  const q = scope === "all" ? "" : `?scope=${scope}`;
  const rst = await get<DeliverySchedule[]>(`/admin/delivery/listSchedule${q}`);
  return rst.data;
}

async function updateSchedule(data: DeliveryScheduleFormData, id: string) {
  await post(`/admin/delivery/updateSchedule`, { id, ...data });
}

async function getSchedule(id: string) {
  const rst = await get<DeliverySchedule>(`/admin/delivery/getSchedule?id=${id}`);
  return rst.data;
}

export async function listPendingItems(data: DeliveryListFilter): Promise<PendingItemsResponse> {
  const rst = await post<Order[] | { orders: Order[]; preparingSchedules: DeliverySchedule[] }>(
    "/admin/delivery/listPendingItems",
    data
  );
  return rst.data;
}

async function updateLogisticItem(data: {
  trackingId: string;
  status: string;
  note: string;
  hasRecycle: boolean;
  frontDoorDropOff: boolean;
}) {
  if (!data.note) data.note = "";
  await post(`/admin/delivery/updateSchedule`, data);
}

async function removeLogisticItem(data: { trackingId: string }) {
  await post(`/admin/delivery/removeLogisticItem`, data);
}

async function removeLogisticOrderItem(data: { trackingId: string; orderProductId: string }) {
  await post(`/admin/delivery/removeLogisticOrderItem`, data);
}

async function appendDelivery(data: AppendDeliveryFormData) {
  await post("/admin/delivery/appendDelivery", data);
}

async function finalizeSchedule(data: FinalizeScheduleFormData) {
  await post("/admin/delivery/finalizeSchedule", data);
}

async function updateLogisticShipping(data: UpdateLogisticShippingFormData) {
  await post("/admin/delivery/updateLogisticShipping", data);
}

const deliveryCore = {
  createVehicle,
  listVehicles,
  getVehicle,
  updateVehicle,
  createSchedule,
  listSchedules,
  getSchedule,
  updateSchedule,
  listPendingItems,
  updateLogisticItem,
  removeLogisticItem,
  removeLogisticOrderItem,
  appendDelivery,
  finalizeSchedule,
  updateLogisticShipping,
};

export default deliveryCore;
